import { useSearchParams } from "react-router-dom";
import { QueryParamBinary, QueryParams } from "../utils/types";
import { CategoryType } from "../components/SearchTags/SearchTags";

export const useFeatureSearchParams = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get(QueryParams.QUERY) || "";
  const searchTagType =
    searchParams.get(QueryParams.SEARCH_TAG_TYPE) === CategoryType.BESPOKE
      ? CategoryType.BESPOKE
      : CategoryType.NORMAL;
  const isQuickSearch =
    searchParams.get(QueryParams.QUICK_SEARCH) === QueryParamBinary.ENABLED;
  const isNameSearch =
    searchParams.get(QueryParams.NAME_SEARCH) === QueryParamBinary.ENABLED;
  return { query, searchTagType, isQuickSearch, isNameSearch };
};
